import { ApiError } from "@vana/core";

export class ListUndeliveredError extends ApiError {}

export class LoadUndeliveredCaseError extends ApiError {}

export class ListAddressesError extends ApiError {}

export class ReconfirmError extends ApiError {}

export class RejectByCustomerError extends ApiError {}

export class ReopenRejectionError extends ApiError {}
